import type { RedrawRequest } from "../redraw";

export interface Child {
  highlight(state?: boolean): RedrawRequest; // Highlight the child
  invalidate(): RedrawRequest; // Invalidate any cached state
}
